/*
 * Oscar4Fox — manufacturer-partner microsite (RECENT-CHANGES-HANDOFF.md item 1
 * and its later-pass follow-up, item 6). A single-product showcase reached from
 * the header nav and from its full-page house ad inside The Southern Air Import
 * (see snippets/sat-import.liquid, assets/sat-import-pager-patch.js).
 *
 * The pattern swatch rail was originally 8 fixed demo patterns with no photos
 * and no real product behind any of them — placeholder names ("Tiger Stripe",
 * "DPM", ...) that didn't correspond to anything for sale. Oscar4Fox is now a
 * real vendor in the catalog with real hooded-combat-shirt listings (tagged
 * "Oscar4Fox"), so the rail is built from those directly: real photo, real
 * name, real stock code, one swatch per product actually on file. A pattern
 * with no matching product just doesn't get a swatch — the rail is exactly as
 * long as the real lineup, nothing invented to fill a fixed count of 8.
 *
 * Still no cart/checkout wiring on this page itself, matching the original
 * design (it's a lookbook, not a listing) — a shopper who wants to buy the
 * pattern they're looking at does it from wherever else it's listed (the
 * Import's page 1 hero slot, the Manifest, etc.), all pointed at the exact
 * same product record this rail now reads from.
 *
 * oscar4foxOpen / oscar4foxActiveId / oscar4foxSize aren't in SATComponent's own
 * initial state object, but setState merges new keys in fine; each is read here
 * with a sensible fallback (first real pattern / size L) so the room opens in a
 * sensible state the first time, before any selection has been made.
 *
 * Merchant: 9 new Oscar4Fox patterns landed in the catalog; asked for
 * Rhodesian specifically as the headliner (also the Import's page-1 hero —
 * see assets/sat-issue-plan-patch.js). Nothing here required a NEW mechanism
 * for that — the rail already reads every Oscar4Fox-tagged product directly
 * from _products, so the new patterns just show up — but the "headliner" part
 * needed one addition: HEADLINER_HANDLE below sorts that one pattern to the
 * front of the rail, which is also what the room opens on by default (see
 * activeId's patterns[0] fallback a few lines down).
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  // Sorted to the front of the rail, and therefore the room's default
  // pattern on open (activeId falls back to patterns[0] until the shopper
  // picks a different swatch). Change this to feature a different pattern
  // next time; leave blank ('') to fall back to whatever order _products
  // happens to return.
  var HEADLINER_HANDLE = 'rhodesian-brushstroke-hooded-combat-shirt';

  // "Flecktarn Hooded Combat Shirt | SAMPLE" -> "Flecktarn". Strips the shirt's
  // own product-type words and any trailing "| SAMPLE"/quote marks so what's
  // left is just the pattern name, the way the original 8 demo entries read.
  function patternNameFromTitle(title) {
    return String(title || '')
      .replace(/\|\s*SAMPLE\s*$/i, '')
      .replace(/\bHooded Combat Shirt\b/i, '')
      .replace(/["“”]/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  // Prefers a plain studio/still shot over a lifestyle shot of someone wearing
  // the shirt, when the product has both — see assets/sat-photo-picker.js. The
  // picker's own fallback is always this product's regular featured photo, so
  // a product with no clear studio alternate just keeps what it already had.
  function bestPhoto(p, onBetter) {
    if (!window.SATPhotoPicker) return p.photo || '';
    return window.SATPhotoPicker.choose(p, onBetter);
  }

  function buildPatterns(products, onBetter) {
    var list = (products || [])
      .filter(function (p) { return p && p.tags && p.tags.indexOf('Oscar4Fox') !== -1; })
      .map(function (p) {
        var name = patternNameFromTitle(p.name) || p.name;
        var chosen = bestPhoto(p, onBetter);
        // Every angle this product has, with the picker's chosen studio shot
        // moved to the front — that keeps the photo shown before a shopper
        // has clicked through anything unchanged (still the picker's best
        // guess), while the rest of the product's real photos (lifestyle
        // shots, other angles) become a browsable rail alongside it instead
        // of being on file but never shown anywhere on this page.
        var images = (p.images || []).filter(Boolean);
        if (chosen) {
          var idx = images.indexOf(chosen);
          if (idx > 0) { images.splice(idx, 1); images.unshift(chosen); }
          else if (idx === -1) { images.unshift(chosen); }
        }
        return {
          id: p.id,
          handle: p.handle,
          name: name,
          tag: p.blurb || '',
          code: 'SAT-' + p.id,
          photo: chosen,
          images: images,
          placeholder: name + ' hooded combat shirt',
          productId: p.id
        };
      });

    if (HEADLINER_HANDLE) {
      var headlinerIdx = list.findIndex(function (pt) { return pt.handle === HEADLINER_HANDLE; });
      if (headlinerIdx > 0) {
        var headliner = list.splice(headlinerIdx, 1)[0];
        list.unshift(headliner);
      }
    }

    return list;
  }

  var SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;
    var size = s.oscar4foxSize || 'L';

    function openOscar4Fox() {
      self.thunk(120, 0.055, 0.045);
      self.setState({ oscar4foxOpen: true });
      window.scrollTo(0, 0);
    }
    function closeOscar4Fox() {
      self.thunk(100, 0.05, 0.04);
      self.setState({ oscar4foxOpen: false });
      window.scrollTo(0, 0);
    }

    out.oscar4foxOpen = !!s.oscar4foxOpen;
    out.oscar4foxShow = s.oscar4foxOpen ? 'flex' : 'none';
    out.openOscar4Fox = openOscar4Fox;
    out.closeOscar4Fox = closeOscar4Fox;
    // Consumed by sections/sat-app.liquid to unmount the app shell's own
    // <header> while this overlay's copy is up — see the comment there.
    out.oscar4foxClosed = !s.oscar4foxOpen;

    // The site header is now rendered inside this overlay too (see
    // snippets/sat-oscar4fox.liquid), so its nav links have to be able to
    // actually leave the overlay — the base handlers only ever change
    // view/page, they don't know this full-screen room exists on top of
    // everything. Wrap each one (when open) to drop oscar4foxOpen first, so
    // clicking e.g. "Manifest" from in here both closes the room and
    // navigates, instead of navigating underneath while the room stays put.
    if (s.oscar4foxOpen) {
      ['goHome', 'goManifest', 'goStore', 'goArchives', 'goCasefiles'].forEach(function (key) {
        var navFn = out[key];
        if (typeof navFn === 'function') {
          out[key] = function () {
            self.setState({ oscar4foxOpen: false });
            navFn.apply(self, arguments);
          };
        }
      });
    }

    var patterns = buildPatterns(self._products, function () {
      // A picker result landed after this render already painted with the
      // fallback photo — nudge state so the next render picks up the cached
      // winner (buildPatterns re-reads the picker's cache every call).
      self.setState({ _photoPickTick: (s._photoPickTick || 0) + 1 });
    });
    var activeId = s.oscar4foxActiveId || (patterns[0] && patterns[0].id);

    out.oscar4foxPatterns = patterns.map(function (pt) {
      return {
        slotId: pt.id, name: pt.name, tag: pt.tag, code: pt.code, photo: pt.photo, placeholder: pt.placeholder,
        select: function () { self.siteTone('c', 0.04); self.setState({ oscar4foxActiveId: pt.id }); },
        ring: activeId === pt.id ? '#E8B930' : '#4A3A2E'
      };
    });
    var activePattern = patterns.filter(function (pt) { return pt.id === activeId; })[0] || patterns[0] || {
      id: '', name: '', tag: '', code: '', photo: '', images: [], placeholder: 'Oscar4Fox hooded combat shirt'
    };

    // Which sub-image of the active pattern is showing. Same two-field
    // pattern as sat-detail-gallery-patch.js (index + "for" id): switching
    // to a different pattern resets back to its own first photo instead of
    // carrying over whatever index was selected on the last one.
    var photoIdx = (s.oscar4foxPhotoFor === activeId) ? (s.oscar4foxPhotoIdx || 0) : 0;
    var activeImages = (activePattern.images && activePattern.images.length) ? activePattern.images : [activePattern.photo];
    if (photoIdx >= activeImages.length) photoIdx = 0;

    out.oscar4foxActive = {
      slotId: activePattern.id, name: activePattern.name, tag: activePattern.tag,
      code: activePattern.code, photo: activeImages[photoIdx] || activePattern.photo,
      placeholder: activePattern.placeholder
    };

    out.oscar4foxThumbs = activeImages.length > 1 ? activeImages.map(function (img, i) {
      var on = i === photoIdx;
      return {
        url: img,
        select: function () {
          self.siteTone('c', 0.03);
          self.setState({ oscar4foxPhotoIdx: i, oscar4foxPhotoFor: activeId });
        },
        borderColor: on ? '#E8B930' : '#4A3A2E',
        dim: on ? '1' : '0.55'
      };
    }) : [];

    out.oscar4foxSpecs = [
      { n: String(patterns.length), label: 'Patterns' },
      { n: 'NIR', label: 'Compliant Shoulders' },
      { n: '1', label: 'Silhouette' },
      { n: '0', label: 'Compromises' }
    ];

    out.oscar4foxSizes = SIZES.map(function (label) {
      var active = size === label;
      return {
        label: label,
        select: function () { self.siteTone('c', 0.035); self.setState({ oscar4foxSize: label }); },
        ring: active ? '#E8B930' : '#4A3A2E',
        bg: active ? '#E8B930' : 'transparent',
        color: active ? '#0C0A08' : '#D8CDB8'
      };
    });

    return out;
  };
})();
